

if(document.querySelector('.twpc-cont svg')){
  document.querySelector('.twpc-cont svg').addEventListener('click',() => {
    hidePincodeModal();
  });
}
if(document.querySelector('.twPincodeOveralay')){
  document.querySelector('.twPincodeOveralay').addEventListener('click',() => {
    hidePincodeModal();
  });
}



// enable atc and checkout button
let enableBtn = () => {
  console.log('enableBtn called')
  document.querySelectorAll('.valid-pincode-checked').forEach((item) => {
    item.setAttribute('checked','');
  });
  pincode = true;
  if(document.querySelector('.product-section')){
    const pdpid = document.querySelector('.product-section').getAttribute('id');
    let pdpbtn = document.querySelector(`#${pdpid} [type="submit"]`);
    if(pdpbtn){
      // disabling the button
      pdpbtn.disabled = false;
    }
  }
  document.querySelectorAll('#CartDrawerForm [type="submit"]').forEach((item) => {
    item.disabled = false;
  })  
  document.querySelector('body').classList.remove('disableCheckout');
}

// disbale atc and checkout button
let disableBtn = (disableClass) => {
  console.log('disableBtn called')
  pincode = false;
  if(document.querySelector('.product-section')){
    const pdpid = document.querySelector('.product-section').getAttribute('id');
    // disabling the button
    document.querySelector(`#${pdpid} [type="submit"]`).disabled = true;
  }

  document.querySelectorAll('#CartDrawerForm [type="submit"]').forEach((item) => {
    item.disabled = true;
  })  

  document.querySelector('body').classList.add(disableClass);
}

//pincode checker
let pincodeJson_url = "https://cdn.shopify.com/s/files/1/2320/8889/files/pinCode_weaves.json?v=1738845125";

// show the pincode modal
let showPincodeModal = (id) => {
  document.querySelector('.twpc-cont').style.display = 'flex';
  document.querySelector('.twPincodeOveralay').style.display = 'block';
  document.querySelector('.twpc-cont .pincheck').setAttribute('data-var-id',id);
}
// hide the pincode modal
let hidePincodeModal = () => {
  document.querySelector('.twpc-cont').style.display = 'none';
  document.querySelector('.twPincodeOveralay').style.display = 'none';
}

// setting the pincode message in differnet parts
let pincodeMsg = (pinMsg,editable) => {
  if(document.querySelector('#modal_opener')) document.querySelector('#modal_opener').textContent = pinMsg;
  if(document.querySelector('.nodelivery_msg')){
    document.querySelectorAll('.nodelivery_msg').forEach((item) => {
      item.textContent = pinMsg;
      // if(editable===true){
      //   item.innerHTML = item.innerHTML + `
      //     <button class="edit-button" onclick="editPincode(event)">
      //       <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="20px" height="20px" viewBox="0 0 494.936 494.936" xml:space="preserve">
      //         <g>
      //         	<g>
      //         		<path d="M389.844,182.85c-6.743,0-12.21,5.467-12.21,12.21v222.968c0,23.562-19.174,42.735-42.736,42.735H67.157    c-23.562,0-42.736-19.174-42.736-42.735V150.285c0-23.562,19.174-42.735,42.736-42.735h267.741c6.743,0,12.21-5.467,12.21-12.21    s-5.467-12.21-12.21-12.21H67.157C30.126,83.13,0,113.255,0,150.285v267.743c0,37.029,30.126,67.155,67.157,67.155h267.741    c37.03,0,67.156-30.126,67.156-67.155V195.061C402.054,188.318,396.587,182.85,389.844,182.85z"/>
      //         		<path d="M483.876,20.791c-14.72-14.72-38.669-14.714-53.377,0L221.352,229.944c-0.28,0.28-3.434,3.559-4.251,5.396l-28.963,65.069    c-2.057,4.619-1.056,10.027,2.521,13.6c2.337,2.336,5.461,3.576,8.639,3.576c1.675,0,3.362-0.346,4.96-1.057l65.07-28.963    c1.83-0.815,5.114-3.97,5.396-4.25L483.876,74.169c7.131-7.131,11.06-16.61,11.06-26.692    C494.936,37.396,491.007,27.915,483.876,20.791z M466.61,56.897L257.457,266.05c-0.035,0.036-0.055,0.078-0.089,0.107    l-33.989,15.131L238.51,247.3c0.03-0.036,0.071-0.055,0.107-0.09L447.765,38.058c5.038-5.039,13.819-5.033,18.846,0.005    c2.518,2.51,3.905,5.855,3.905,9.414C470.516,51.036,469.127,54.38,466.61,56.897z"/>
      //         	</g>
      //         </g>
      //       </svg>
      //     </button>
      //   `;
      //   console.log('edit button incoming');
      // }
    });
  } 
  // if(document.querySelector('#modal_opener')) document.querySelector('#modal_opener').classList.remove('d-none')
}
let pincodeMsgEmpty = () => {
  document.querySelector('#modal_opener').textContent = '';
  if(document.querySelector('.nodelivery_msg')){
    document.querySelectorAll('.nodelivery_msg').forEach((item) => {
      item.textContent = pinMsg;
    })
  } 
  document.querySelector('#modal_opener').classList.add('d-none')
}
let pincodeCheck = (userPincode, id) => {
  if (userPincode.length != 6) {
    console.log('Invalid pincode length');
    pincodeMsg(`Please enter a valid pincode`);
    disableBtn('disableCheckout');
    return false;
  }

  let is_pincode_available = pincodesJson.filter(item => item.pincode == userPincode);

  sessionStorage.setItem("pincode", userPincode);

  if (is_pincode_available.length) {
    enableBtn();

    const codAvailability = is_pincode_available[0].cod === "Y" ? "COD is available." : "COD is not available.";
    let deliveryMessage = `Ready to deliver to Pincode: ${userPincode}.`;

    if (is_pincode_available[0].sameDayDelivery) {
      deliveryMessage += " Next day delivery available.";
    }

    deliveryMessage += ` ${codAvailability}`;
    pincodeMsg(deliveryMessage, true);

    if (document.querySelector('.twpc-cont').style.display == 'flex') {
      setTimeout(() => {
        hidePincodeModal();
      }, 1000);
    }

    customATC(id, event, '1');
  } else {
    // Pincode is not available
    pincodeMsg(`We cannot deliver to Pincode: ${userPincode}.  COD is not available.`, true);
    disableBtn('disableCheckout');
    document.documentElement.style.setProperty('--disableText', `'We do not deliver in your pincode'`);
  }
};

let pincodeOnloadCheck = () => {
  let sessionPincode = sessionStorage.getItem("pincode");
  if(sessionPincode) pincodeCheck(sessionPincode)
}

if(document.querySelector('.pincheck')){
  document.querySelectorAll('.pincheck').forEach((item)=>{
    item.addEventListener('click', (event) => {
      var target = event.target;
      var nearestParent = target.closest('.pc-top');
      var thisInputField = nearestParent.querySelector('#pincode_input');
      console.log(thisInputField);
      if(target.getAttribute('data-var-id') != 'undefined'){
        pincodeCheck(thisInputField.value,target.getAttribute('data-var-id'));
      } else {
        pincodeCheck(thisInputField.value);
      }
    });
  })
}

function editPincode(event) {
  let currentParent = event.target.closest('.pincode-wrapper');
  let inputField = currentParent.querySelector('.valid-pincode-checked')
  inputField.removeAttribute('checked');
}


// disabling all the buttons on load
disableBtn('disableCheckout');
//storing the list of pincodes
let pincodesJson;
fetch(pincodeJson_url)
    .then(response => response.json())
    .then(data => {
        pincodesJson = data['pincodes'];
        pincodeOnloadCheck();
    })
    .catch(error => {
        console.error('Error fetching data:', error);
    });

document.addEventListener('quickview:open', function(evt) {
  console.log('this is working');
  setTimeout(() => {
    console.log('quickview:open')
    disableBtn('disableCheckout')
    if(pincode == false) {
      pincodeOnloadCheck();
    }
  }, "1000");
});


// <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="20px" height="20px" viewBox="0 0 494.936 494.936" xml:space="preserve">
//   <g>
//     <g>
//         <path d="M389.844,182.85c-6.743,0-12.21,5.467-12.21,12.21v222.968c0,23.562-19.174,42.735-42.736,42.735H67.157    c-23.562,0-42.736-19.174-42.736-42.735V150.285c0-23.562,19.174-42.735,42.736-42.735h267.741c6.743,0,12.21-5.467,12.21-12.21    s-5.467-12.21-12.21-12.21H67.157C30.126,83.13,0,113.255,0,150.285v267.743c0,37.029,30.126,67.155,67.157,67.155h267.741    c37.03,0,67.156-30.126,67.156-67.155V195.061C402.054,188.318,396.587,182.85,389.844,182.85z"/>
//         <path d="M483.876,20.791c-14.72-14.72-38.669-14.714-53.377,0L221.352,229.944c-0.28,0.28-3.434,3.559-4.251,5.396l-28.963,65.069    c-2.057,4.619-1.056,10.027,2.521,13.6c2.337,2.336,5.461,3.576,8.639,3.576c1.675,0,3.362-0.346,4.96-1.057l65.07-28.963    c1.83-0.815,5.114-3.97,5.396-4.25L483.876,74.169c7.131-7.131,11.06-16.61,11.06-26.692    C494.936,37.396,491.007,27.915,483.876,20.791z M466.61,56.897L257.457,266.05c-0.035,0.036-0.055,0.078-0.089,0.107    l-33.989,15.131L238.51,247.3c0.03-0.036,0.071-0.055,0.107-0.09L447.765,38.058c5.038-5.039,13.819-5.033,18.846,0.005    c2.518,2.51,3.905,5.855,3.905,9.414C470.516,51.036,469.127,54.38,466.61,56.897z"/>
//     </g>
//   </g>
// </svg>